import { i18n } from 'locales';

import { createApp } from 'vue';

import SupportForm from 'components/support/SupportForm.vue';
import SupportTopicPicker from 'components/support/SupportTopicPicker.vue';
import Support from 'components/support/Support.vue';

import { createPinia } from 'pinia';

const pinia = createPinia();
const app = createApp();
app.use(i18n);
app.use(pinia);

app.component(SupportForm.name, SupportForm);
app.component(SupportTopicPicker.name, SupportTopicPicker);
app.component(Support.name, Support);

app.mount('#support-container');
